<template>
<v-card flat >
  <v-card-title
    v-if="activeStep"
    class='subtitle-1 overline grey lighten-4 py-0' >

    <v-btn icon
      v-if='activeStep.back && activeStep.back.visible'
      :disabled='activeStep.back.disabled || loading'
      @click='window--' >
      <v-icon>arrow_back</v-icon>
    </v-btn>

    <v-spacer/>
    {{activeStep.title}}
    <v-spacer/>

    <v-btn icon
      v-if='activeStep.next && activeStep.next.visible'
      :disabled='activeStep.next.disabled || loading'
      @click='next(activeStep, obj)' >
      <v-icon>arrow_forward</v-icon>
    </v-btn>

  </v-card-title>
  <v-window v-model="window" touchless >
    <v-window-item v-for='step in steps' :key='step.id' >
      <v-component
        v-if='step.component'
        :is='step.component'
        v-model='obj[step.id]'
        v-bind='step.attrs'
        v-on='step.events'
        @close='$emit("cancel")'
        @cancel='$emit("cancel")'  />
      <template v-else >
        <v-textarea autofocus
          v-if='step.vcomponent && step.vcomponent === "vtextarea"'
          class='ma-5'
          v-model='obj[step.id]'
          v-bind='step.attrs'
          v-on='step.events' />
        <v-radio-group
          v-else-if='step.vcomponent && step.vcomponent === "vradiogroup"'
          class='ma-5'
          v-model='obj[step.id]'
          v-bind='step.attrs'
          v-on='step.events' >
          <v-radio
            v-for='item in step.attrs.items'
            :key='item.value'
            :value='item.value'
            :label='item.text' />
        </v-radio-group>
        <v-text-field v-else autofocus
          class='ma-5'
          v-model='obj[step.id]'
          v-bind='step.attrs'
          v-on='step.events'
          @keypress.enter='next(step, obj)' />
      </template>
    </v-window-item >
    <v-window-item value='success' >
      <slot name='success' >
      </slot>
    </v-window-item >
  </v-window>
  <!-- <pre v-text="obj" /> -->
  <v-divider/>
  <v-card-actions >
    <v-btn flat text @click='$emit("cancel")' >
      cancel
    </v-btn>
    <v-spacer />
    <v-btn flat text
      v-if='activeStep && activeStep.required === false'
      @click='window++' >
      skip
    </v-btn>
    <v-btn text
      :loading='loading'
      :disabled='activeStep.isValid && !activeStep.isValid(activeStep, obj)'
      @click='next(activeStep, obj)'
      color='primary' >
      {{ activeStep.nextText || "next" }}
    </v-btn>
  </v-card-actions>
  <!-- <pre v-text='obj' /> -->
</v-card>
</template>
<script>
export default {
  name: 'WizLayout',
  props: {
    value: { type: Object, required: false },
    steps: { type: Array, required: true },
    initialStep: { default: 0 },
    loading: { type: Boolean, default: false }
  },
  data () {
    return {
      window: 0,
      obj: {}
    }
  },
  methods: {
    next (step, obj) {
      if (this.loading) { return null }
      if (step && step.isValid && step.isValid(step, obj)) {
        if (step.onNext) {
          step.onNext(step, obj)
        } else {
          this.window++
        }
      } else {
        // window.alert('This step has not passed validation')
      }
    }
  },
  watch: {
    initialStep () {
      this.window = this.initialStep
    },
    window () {
      this.$emit('update:initialStep', this.window)
    },
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.obj = this.value
        }
      }
    },
    obj () {
      this.$emit('input', this.obj)
    }
  },
  computed: {
    activeStep () {
      console.log(this.window, this.steps.length)
      if (this.window > this.steps.length - 1) { this.window = 'success' }
      if (this.window === 'success') { return this.successStep }
      return this.steps[this.window]
    },
    successStep () {
      return {
        id: 'success',
        title: 'Space created',
        back: { visible: false },
        next: { visible: false },
        required: false,
        isValid: () => { return false }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// WizLayout.vue?604bbc8d